export default "__VITE_PUBLIC_ASSET__888e9a28__"